import { useFormik } from "formik";
import React from "react";
import { Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as yup from "yup";
import GoogleMapComponent from "../../Common/Components/GoogleMapComponent";
import { fetchAreas } from "../../Services/MainService";
import { addAddress, updateAddress } from "../Services/AddressesService";

const AddressType = ({ value, onChange, selected, label, icon }) => {
  return (
    <div
      className={`card cursor-pointer ${
        selected === value ? "border-primary" : "border-muted"
      }`}
      style={{ width: "fit-content", transition: "300ms" }}
      onClick={() => {
        if (onChange) onChange(value);
      }}
    >
      <div className="card-body d-flex align-items-center py-2">
        <i
          className={`fa-solid fa-${icon} ${
            selected === value ? "text-primary" : "text-muted"
          } me-2`}
          style={{ transition: "300ms" }}
        ></i>
        <p
          className={`mb-0 fw-semibold ${
            selected === value ? "text-primary" : "text-muted"
          }`}
          style={{ transition: "300ms" }}
        >
          {label}
        </p>
      </div>
    </div>
  );
};

const addressTypes = [
  {
    id: "home",
    label: "Home",
    icon: "home",
  },
  {
    id: "office",
    label: "Office",
    icon: "briefcase",
  },
  {
    id: "others",
    label: "Other",
    icon: "location-dot",
  },
];

const validationSchema = yup.object({
  address1: yup.string().required("This Field is required!"),
  address2: yup.string(),
  area_id: yup
    .string()
    .required("This Field is required!")
    .test("is-non-zero", "This Field is required", (value) => value !== "0"),
  area_phase_id: yup
    .string()
    .required("This Field is required!")
    .test("is-non-zero", "This Field is required", (value) => value !== "0"),
  contact_person_name: yup.string().required("This Field is required!"),
  contact_person_number: yup
    .string()
    .required("This Field is required!")
    .matches(/^(3)|(2)([0-9]{9})$/g, "Please enter a valid number!"),
  address: yup.string().required("Please select a location from Map!"),
});

export const AddAddress = ({
  show = true,
  onHide = null,
  onAdd = null,
  addy = null,
}) => {
  // const [location, setLocation] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [areas, setAreas] = React.useState([]);
  const [phases, setPhases] = React.useState([]);
  const [submitting, setSubmitting] = React.useState(false);
  const customer = useSelector((x) => x.Customer);
  const customerId = useSelector((x) => x.CustomerId);
  const formik = useFormik({
    initialValues: {
      // id: null,
      address_type: "home",
      contact_person_number: "",
      address: "",
      latitude: "",
      longitude: "",
      zoneId: null,
      contact_person_name: "",
      laundryZoneId: null,
      area_id: 0,
      area_phase_id: 0,
      address1: "",
      address2: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        ...values,
        contact_person_number: `+92${values.contact_person_number}`,
        user_id: customerId,
      };
      if (!values.address_type) {
        payload.address_type = "home";
      }
      setSubmitting(true);
      console.log(payload);
      const method = payload?.id ? updateAddress : addAddress;
      method(payload).then(
        (res) => {
          setSubmitting(false);
          if (onAdd) onAdd(payload);
          formik.resetForm();
        },
        (er) => {
          setSubmitting(false);
          if (er && er.errors && er.errors.length > 0) {
            er.errors.forEach((x) => toast.error(x.message));
          } else
            toast.error(
              `Something went wrong while ${
                payload?.id ? "updating" : "adding"
              } new address...`
            );
        }
      );
    },
  });

  React.useEffect(() => {
    if (addy) {
      const payload = {
        ...addy,
        contact_person_number: addy.contact_person_number?.replace(/\+92/g, ""),
      };
      console.log(payload);
      formik.setValues(payload);
      formik.validateForm();
      handleArea(payload.area_id);
    }
  }, [addy]);

  // React.useEffect(() => {
  //   if (customer) {
  //     formik.setFieldValue("contact_person_number", customer.phone);
  //     formik.setFieldValue(
  //       "contact_person_name",
  //       `${customer.f_name} ${customer.l_name}`
  //     );
  //   }
  // }, [customer, addy, show]);

  const handleLocationChange = (e) => {
    console.log(e);
    formik.setValues((x) => ({
      ...x,
      address: e?.address || null,
      latitude: e?.cords?.lat || null,
      longitude: e?.cords?.lng || null,
      zoneId: e?.zone || null,
      laundryZoneId: e?.zone || null,
    }));
  };
  React.useEffect(() => {
    _fetchAreas();
  }, []);

  const _fetchAreas = () => {
    setLoading(true);
    fetchAreas()
      .then(
        (res) => {
          setAreas(res);
          if (formik.values.area_id) {
            if (areas.length > 0) {
              handleArea(formik.values.area_id);
            }
          }
        },
        () => {
          toast.error("Something went wrong while fetching areas!");
        }
      )
      .finally(() => setLoading(false));
  };
  const handleArea = (area_id) => {
    const area = areas.find((x) => x.id == area_id);
    if (area) {
      formik.setFieldValue("area_id", area?.id);
      setPhases(area?.area_phase);
    }
  };

  return (
    <Modal
      show={show}
      // backdrop="static"
      // keyboard={false}
      fullscreen={true}
      centered
      style={{ zIndex: 1056 }}
      onHide={() => {
        if (onHide) onHide(false);
        formik.resetForm();
      }}
    >
      <Modal.Body className="pt-0">
        <div className="col-12 text-end pt-2">
          <span
            className=" text-muted cursor-pointer"
            onClick={() => {
              if (onHide) onHide(false);
              formik.resetForm();
            }}
          >
            <i className="fa-solid fa-xmark" style={{ fontSize: "20px" }}></i>
          </span>
        </div>
        <div className="container-fluid bg-white">
          <div
            className="row justify-content-center"
            style={{ padding: "20px 0px" }}
          >
            <div className="col-lg-6 col-md-8 col-12 text-center">
              <h1
                className="fw-bold"
                style={{
                  fontSize: "38px",
                  marginBottom: "26px",
                  color: "#656565",
                }}
              >
                We're missing some details
              </h1>
              <span style={{ fontSize: "18px", color: "#656565" }}>
                Please provide complete address details below
              </span>
            </div>
          </div>
        </div>
        <div className="container" style={{ borderTop: "1px solid #E5E7EB" }}>
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-11 mt-3">
              {/* <div>
                <label className="fw-semibold form-label">
                  YOUR PICKUP / DELIVERY ADDRESS
                </label>
                <div className="card">
                  <div className="card-body">
                    <div className="col-11 ps-0">
                      <p className="m-0 d-flex align-items-center">
                        <i
                          className="fa-solid fa-location-dot me-3"
                          style={{ color: "#32b6e9", fontSize: "24px" }}
                        ></i>
                        {formik.values.address ||
                          "Select Location on map and click pickup location"}
                      </p>
                    </div>
                  </div>
                </div>
                {Boolean(formik.errors.address) ? (
                  <p className="text-danger fw-semibold ms-1">
                    {formik.errors.address}
                  </p>
                ) : null}
              </div> */}
              <div className="row">
                <div className="form-group col-md-6 col-12 py-3">
                  <label className="fw-semibold form-label">
                    Address Line 1
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Address Line 1"
                    id="address1"
                    name="address1"
                    value={formik.values.address1}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {Boolean(formik.errors.address1) &&
                  formik.touched.address1 ? (
                    <span className="text-danger">
                      {formik.errors.address1}
                    </span>
                  ) : null}
                </div>
                <div className="form-group col-md-6 col-12 py-3">
                  <label className="fw-semibold form-label">
                    Address Line 2
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Address Line 2"
                    id="address2"
                    name="address2"
                    value={formik.values.address2}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {Boolean(formik.errors.address2) &&
                  formik.touched.address2 ? (
                    <span className="text-danger">
                      {formik.errors.address2}
                    </span>
                  ) : null}
                </div>
                <div className="form-group col-md-6 col-12 py-3">
                  <label className="fw-semibold form-label">Area</label>
                  <select
                    type="text"
                    className="form-control form-select"
                    id="area_id"
                    name="area_id"
                    value={formik.values.area_id}
                    onChange={(e) => handleArea(e.target.value)}
                    onBlur={formik.handleBlur}
                  >
                    <option value={0} disabled>
                      Select Area
                    </option>
                    {areas.map((area) => (
                      <option value={area.id} key={`area-${area.id}`}>
                        {area.name}
                      </option>
                    ))}
                  </select>
                  {Boolean(formik.errors.area_id) && formik.touched.area_id ? (
                    <span className="text-danger">{formik.errors.area_id}</span>
                  ) : null}
                </div>
                <div className="form-group col-md-6 col-12 py-3">
                  <label className="fw-semibold form-label">Phase</label>
                  <select
                    type="text"
                    className="form-control form-select"
                    id="area_phase_id"
                    name="area_phase_id"
                    value={formik.values.area_phase_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value={0} disabled>
                      Select Phase
                    </option>
                    {phases?.map((phase) => (
                      <option value={phase.id} key={`area-phase-${phase.id}`}>
                        {phase.name}
                      </option>
                    ))}
                  </select>
                  {Boolean(formik.errors.area_phase_id) &&
                  formik.touched.area_phase_id ? (
                    <span className="text-danger">
                      {formik.errors.area_phase_id}
                    </span>
                  ) : null}
                </div>

                {/* <div className="form-group col-md-6 col-12 py-3">
                  <label className="fw-semibold form-label">Sector</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sector"
                    id="sector"
                    name="sector"
                    value={formik.values.sector}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div className="form-group col-md-6 col-12 py-3">
                  {" "}
                  <label className="fw-semibold form-label">
                    Building or Block
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Building or Block"
                    id="building"
                    name="building"
                    value={formik.values.building}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div className="form-group col-md-6 col-12 py-3">
                  <label className="fw-semibold form-label">
                    Street Name or No.
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Street Name or No."
                    id="streetNo"
                    name="streetNo"
                    value={formik.values.streetNo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div> */}
              </div>
              <div className="py-3">
                <label className="form-label fw-semibold mb-3">Label As</label>
                <div className="d-flex flex-wrap align-items-center gap-3">
                  {addressTypes.map((x) => (
                    <AddressType
                      key={x.id}
                      icon={x.icon}
                      label={x.label}
                      value={x.id}
                      selected={formik.values.address_type}
                      onChange={(e) => formik.setFieldValue("address_type", e)}
                    />
                  ))}
                </div>
              </div>
              <div className="pt-4 pb-2">
                <h4 className="fw-bold">Additional Contact Details</h4>
                <h6>
                  Please enter the details of the contact our rider should
                  connect with upon pickup / delivery.
                </h6>
              </div>
              <div className="row">
                <div className="form-group col-md-6 col-12 py-3">
                  <label className="fw-semibold form-label">
                    Contact Person Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      Boolean(formik.errors.contact_person_name) &&
                      formik.touched.contact_person_name
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Contact Person Name"
                    id="contact_person_name"
                    name="contact_person_name"
                    value={formik.values.contact_person_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {Boolean(formik.errors.contact_person_name) &&
                  formik.touched.contact_person_name ? (
                    <span className="text-danger fw-semibold mt-1 d-inline-block ms-1">
                      {formik.errors.contact_person_name}
                    </span>
                  ) : null}
                </div>
                {/* <div className="form-group col-md-6 col-12 py-3">
                  <label className="fw-semibold form-label">
                    Contact Person Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      Boolean(formik.errors.contact_person_number) &&
                      formik.touched.contact_person_number
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Phone"
                    id="contact_person_number"
                    name="contact_person_number"
                    value={formik.values.contact_person_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {Boolean(formik.errors.contact_person_number) &&
                  formik.touched.contact_person_number ? (
                    <span className="text-danger fw-semibold mt-1 d-inline-block ms-1">
                      {formik.errors.contact_person_number}
                    </span>
                  ) : null}
                </div> */}

                <Form.Group
                  className="col-md-6 col-12 py-3"
                  controlId="contact_person_number"
                >
                  <Form.Label className="fw-semibold">
                    Contact Person Number
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text>+92</InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="contact_person_number"
                      placeholder="xxxxxxxxxx"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.contact_person_number}
                      className={`${
                        Boolean(formik.errors.contact_person_number) &&
                        formik.touched.contact_person_number
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                  </InputGroup>
                  {Boolean(formik.errors.contact_person_number) &&
                  formik.touched.contact_person_number ? (
                    <span className="text-danger fw-semibold mt-1 d-inline-block ms-1">
                      {formik.errors.contact_person_number}
                    </span>
                  ) : null}
                </Form.Group>
              </div>
            </div>
            <div className="col-lg-10 col-md-11 mt-3">
              <hr style={{ borderStyle: "dashed" }} />
            </div>
            <div className="col-lg-10 col-md-11 mt-3">
              <h4 className="fw-bold ">Select your location on map</h4>
              <div style={{ height: "60vh" }}>
                <GoogleMapComponent
                  handleSelect={handleLocationChange}
                  noBtn={true}
                  cords={addy?.cords}
                />
              </div>
              {Boolean(formik.errors.address) ? (
                <p className="text-danger fw-semibold mt-2 ms-1">
                  {formik.errors.address}
                </p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="container-fluid bg-white">
          <div
            className="row justify-content-center"
            style={{ padding: "40px 0px" }}
          >
            <div
              className="d-flex col-lg-6 col-md-7 col-12 justify-content-center"
              style={{ columnGap: "20px" }}
            >
              <button
                className="service-btn next"
                disabled={submitting}
                onClick={() => {
                  if (!submitting) {
                    if (!formik.isValid)
                      toast.error("Please fill up the required fields...");
                    formik.handleSubmit();
                  }
                }}
              >
                {submitting ? <Spinner size="sm" /> : null}
                Save Location
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
